import dayjs from 'dayjs';
export const FORM_CHANGE_BOOKING_DATE = ({ defaultValues, warranty, optionsReasonChangeBookingDate, watch }) => {
  const reasonCodeWatch = watch('reasonCode');
  const expireDate = warranty?.expireDate;
  return [
    {
      name: 'warrantyCode',
      label: 'รหัสรับประกัน',
      type: 'INPUT',
      span: 12,
      disabled: true,
      defaultValue: defaultValues?.warrantyCode || '',
      rules: {
        required: {
          value: true,
          message: 'ไม่พบรหัสรับประกันสินค้ากรุณาออกแล้วเข้าใหม่อีกครั้ง',
        },
      },
    },
    {
      name: 'claimCode',
      label: 'รหัสการเคลม',
      type: 'INPUT',
      span: 12,
      disabled: true,
      defaultValue: defaultValues?.claimCode || '',
      rules: {
        required: {
          value: true,
          message: 'ไม่พบเลขที่เคลมกรุณาออกแล้วเข้าใหม่อีกครั้ง',
        },
      },
    },
    {
      name: 'storeName',
      label: 'ร้านค้า',
      type: 'INPUT',
      span: 12,
      disabled: true,
      defaultValue: defaultValues?.storeName || '',
    },
    {
      name: 'storePhoneNumber',
      label: 'หมายเลขติดต่อ',
      type: 'INPUT',
      span: 12,
      disabled: true,
      defaultValue: defaultValues?.storePhoneNumber || '',
    }, {
      name: 'expireDate',
      label: 'วันหมดอายุรับประกัน',
      type: 'INPUT',
      span: 12,
      disabled: true,
      defaultValue: warranty?.expireDate || '',
    },
    {
      name: 'bookingDate',
      label: 'จองวันเคลมสินค้า',
      type: 'DATE_PICKER',
      span: 12,
      rules: {
        required: true,
        message: 'กรุณาเลือกวันจองใหม่',
      },
      disabledDate: (current) => {
        const minDate = dayjs().add(2, 'day').startOf('day');
        const maxDate15Days = dayjs().add(15, 'day').startOf('day');
        const expireMaxDate = expireDate ? dayjs(expireDate).startOf('day') : null;
        const maxDate =
          expireMaxDate && expireMaxDate.isValid() && expireMaxDate.isBefore(maxDate15Days)
            ? expireMaxDate
            : maxDate15Days;
        return current && (current < minDate || current > maxDate);
      },
    },
    {
      name: 'reasonCode',
      label: 'เหตุผลที่เปลี่ยนวันจอง',
      type: 'DROPDOWN',
      placeholder: 'เลือกเหตุผล',
      span: 12,
      properties: {
        options: optionsReasonChangeBookingDate || [],
      },
      rules: {
        required: {
          value: true,
          message: 'กรุณาเลือกเหตุผล',
        },
      },
      style: { width: '100%', height: '100%', minHeight: '32px' },
    },
    ...(reasonCodeWatch === 'OTHER' ? [
      {
        name: 'remark',
        label: 'เหตุผลเพิ่มเติม',
        type: 'INPUT',
        span: 12,
        rules: {
          required: true,
          message: 'กรุณากรอกเหตุผลเพิ่มเติม',
        },
      },
    ] : []),
  ];
};
